import { createAction, props } from '@ngrx/store';
import { Material, SteelType } from '@shared/models';

export enum CarbonImpactActions {
  ResetIndirectImpacts = '[Carbon Impacts /  Stages Container] Reset values to default',
  SubmitCapacityOfFarm = '[Carbon Impacts /  Stages Container] Submit the capacity of farm value',
  SubmitCompositeCapacity = '[Carbon Impacts /  Stages Container] Submit the composite capacity factor',
  UpdateSelectedMaterialCI = '[Carbon Impacts / Stages Container] Update the selected material from the carbon impact page',
  UpdateSelectedSteelType = '[Carbon Impacts /  Stages Container] update the selected steel type',
}

export const ResetIndirectImpacts = createAction(
  CarbonImpactActions.ResetIndirectImpacts
);

export const SubmitCapacityOfFarm = createAction(
  CarbonImpactActions.SubmitCapacityOfFarm,
  props<{ capacityOfFarm: number }>()
);

export const SubmitCompositeCapacity = createAction(
  CarbonImpactActions.SubmitCompositeCapacity,
  props<{ compositeCapacity: number }>()
);

export const UpdateSelectedMaterialCI = createAction(
  CarbonImpactActions.UpdateSelectedMaterialCI,
  props<{ selectedMaterial: Material }>()
);

export const UpdateSelectedSteelType = createAction(
  CarbonImpactActions.UpdateSelectedSteelType,
  props<{ selectedSteelType: SteelType }>()
);
